'use strict'
module.exports = {
  NODE_ENV: '"production"',
  API_ROOT:'"http://127.0.0.1:9090"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1